import { ChangeDetectionStrategy, Component } from '@angular/core';
import { WebBaseControlTypedSettingsComponent } from '@web/widgets/common/abstract/web-base-control-typed-settings.component';
import { type CartIconSettingsFormGroupType } from '@web/widgets/shop-cart/type/shop-cart-widget.type';
import { TranslateModule } from '@ngx-translate/core';
import { WebSettingsModule } from '@web/shared/components/web-settings/web-settings.module';
import { SpShopCartIconSettingsModule } from '@components/sp-shop-cart-icon-settings';

@Component({
    selector: 'web-shop-cart-icon-settings',
    templateUrl: './shop-cart-icon-settings.component.html',
    styleUrls: ['./shop-cart-icon-settings.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [WebSettingsModule, TranslateModule, SpShopCartIconSettingsModule],
})
export class ShopCartIconSettingsComponent extends WebBaseControlTypedSettingsComponent<CartIconSettingsFormGroupType> {}
